import type { Translations } from "../keys.js";

export const es = {
  eyebrow: "Estado de actividad IBKR",
  title: "Informe de relación P/L",
  uploadMark: "Flex XML",
  uploadTitle: "Suelta o elige XML de IBKR",
  uploadBody: "Nombre, cuenta y dirección se muestran anonimizados.",
  nfaDisclaimer: "Solo para aprendizaje y revisión de operaciones. No es asesoramiento financiero.",
  chooseFile: "Elegir archivo",
  account: "Cuenta",
  name: "Nombre",
  neutralName: "momo",
  period: "Periodo",
  baseCurrency: "Divisa base",
  closed: "cerradas",
  executions: "ejecuciones",
  netRealized: "Realizado neto",
  winRate: "Tasa de acierto",
  payoffRatio: "Relación P/L",
  expectancy: "Expectativa",
  executionRecords: "Ejecuciones",
  canceledOrders: "Órdenes canceladas",
  medianHoldingDays: "Mediana de días en posición",
  commissionDrag: "Comisiones",
  closedTradeSum: "Total de cierres",
  grossProfitLoss: "Ganancia bruta / pérdida bruta",
  averageWinLoss: "Ganancia media / pérdida media",
  perClosedTrade: "Media por cierre",
  flexTradeRecords: "Registros Trade en Flex XML",
  flexCanceledRecords: "Registros Order cancelados en Flex XML",
  noCanceledRecords: "Sin órdenes canceladas en este XML",
  holdingReview: "Holding",
  holdingReviewTitle: "Análisis de tenencia y relación P/L",
  holdingReviewHint: "Empareja aperturas y cierres para comparar PF, P/L y acierto por periodo de tenencia.",
  holdingPeriod: "Periodo de tenencia",
  holdingIntraday: "Intradiario",
  holdingSwing: "1-7 días",
  holdingPosition: "8-30 días",
  holdingLongTerm: "30+ días",
  directionReview: "Direction",
  directionReviewTitle: "Análisis largo / corto",
  directionReviewHint: "Separa las operaciones cerradas por exposición de estrategia para ver qué lado tiene ventaja.",
  longPosition: "Largo",
  shortPosition: "Corto",
  neutralPosition: "Neutral",
  equityCurve: "Curva de capital",
  dailyRealized: "P/L diario realizado",
  payoff: "Payoff",
  winLossDistribution: "Distribución de ganancias y pérdidas",
  periodPerformance: "Rendimiento por periodo",
  periodHint: "Barras verdes: ganancia; rojas: pérdida. PF y ratio P/L están en la tabla inferior.",
  weekly: "Semanal",
  monthly: "Mensual",
  periodColumn: "Periodo",
  monthColumn: "Mes",
  realized: "Realizado",
  profitFactor: "Profit Factor",
  pf: "PF",
  payoffShort: "P/L",
  trades: "Trades",
  assetBreakdown: "Activos",
  assetBreakdownTitle: "Estadísticas acciones / opciones",
  asset: "Activo",
  medianPnl: "P/L mediano",
  average: "Media",
  optionReview: "Opciones",
  optionReviewTitle: "Opciones por subyacente",
  underlying: "Subyacente",
  date: "Fecha",
  dateCount: "Fechas",
  daysShort: "d",
  hoursShort: "h",
  minutesShort: "min",
  weakestSession: "Sesión más débil",
  intradaySessionNoData: "Sin cierres de sesión regular",
  intradaySessionTitle: "Acierto en apertura / mediodía / cierre",
  intradaySessionHint: "Agrupa cierres por sesión para comparar realizado, P/L mediano, promedio, PF, ratio P/L y acierto.",
  weekdayReviewTitle: "Rendimiento por día de la semana",
  weekdayReviewHint: "Compara cierres de sesión regular y vencimientos automáticos por día para mostrar la mejor y peor relación P/L.",
  weekday: "Día",
  weekdaySunday: "Domingo",
  weekdayMonday: "Lunes",
  weekdayTuesday: "Martes",
  weekdayWednesday: "Miércoles",
  weekdayThursday: "Jueves",
  weekdayFriday: "Viernes",
  weekdaySaturday: "Sábado",
  bestDay: "Mejor",
  worstDay: "Peor",
  session: "Sesión",
  sessionMorning: "Apertura",
  sessionMidday: "Mediodía",
  sessionLate: "Cierre",
  autoExpiry: "Vencimiento auto",
  optionLifecycle: "Vencimiento / liquidación",
  optionLifecycleRegularClose: "Cierre normal",
  optionLifecycleEp: "Vencida",
  optionLifecycleEx: "Ejercicio",
  optionLifecycleA: "Asignación",
  optionLifecycleCD: "Liquidación en efectivo",
  optionLifecycleAEx: "Ejercicio automático",
  optionLifecycleMEx: "Ejercicio manual",
  optionLifecycleGEA: "Vencimiento / asignación compensada",
  discipline: "Disciplina",
  disciplineRisk: "Riesgo de disciplina",
  largeLossAlert: "Alerta de pérdida grande",
  largeLossDiscipline: "Pausa primero. Protege la disciplina.",
  largeLossRule: "La pérdida total de este día supera el umbral actual de riesgo. No aumentes tamaño para recuperarla antes de revisar stop planificado, pérdida diaria máxima y regla de pausa.",
  worstLossDay: "Peor día de pérdida",
  symbols: "Símbolos",
  symbolPerformance: "Clasificación de símbolos",
  page: "Página",
  previousPage: "Página anterior",
  nextPage: "Página siguiente",
  offlineCoach: "Coach offline",
  offlineAdvice: "Consejos offline",
  bestLoserWins: "El mejor perdedor gana",
  theme: "Tema",
  language: "Idioma",
  dark: "Oscuro",
  light: "Claro",
  stock: "Acciones",
  option: "Opciones",
  other: "Otros",
  cash: "Efectivo",
  future: "Futuro",
  unknown: "Desconocido",
  lossBucketSmall: "Pérdida pequeña",
  lossBucketMedium: "Pérdida media",
  lossBucketLarge: "Pérdida grande",
  winBucketSmall: "Ganancia pequeña",
  winBucketMedium: "Ganancia media",
  winBucketLarge: "Ganancia grande",
  chartEmpty: "No hay cierres para graficar",
  dailyChartLegend: "barras: diario, línea: acumulado",
  periodChartLegend: "puntos PF, ref. 1.00, límite",
  importFailed: "Error al importar",
  profitStatus: "Ganancia",
  lossStatus: "Pérdida",
  flatStatus: "Plano",
  costStatus: "Coste",
  toggleDetails: "Ver detalles",
  "error.invalid_flex_xml": "Sube un archivo IBKR Flex XML.",
  "advice.profit_factor_below_one.title": "El PF está por debajo de 1",
  "advice.profit_factor_below_one.body": "El PF actual es {profitFactor}. Las ganancias totales aún no cubren las pérdidas totales. Antes de aumentar operaciones, reduce pérdidas grandes, pérdidas por vencimiento y añadidos sin control.",
  "advice.profit_factor_thin_edge.title": "El PF tiene poco margen",
  "advice.profit_factor_thin_edge.body": "El PF actual es {profitFactor}. Es operable, pero una o dos pérdidas fuera de control pueden borrar todo el periodo. Define primero pérdida diaria máxima, última salida aceptable y reglas de pausa.",
  "advice.profit_factor_healthy.title": "La estructura del PF es más sana",
  "advice.profit_factor_healthy.body": "El PF actual es {profitFactor}. No aumentes la frecuencia a ciegas. Identifica qué símbolos, sesiones y setups son repetibles y conserva solo las operaciones de mayor calidad.",
  "advice.winrate_and_payoff_weak.title": "Acierto y payoff no pueden ser débiles a la vez",
  "advice.winrate_and_payoff_weak.body": "La tasa de acierto es {winRate} y el payoff es {payoffRatio}. Ni la tasa de acierto ni la recompensa media compensan lo suficiente. Confirma espacio objetivo y distancia de stop antes de entrar.",
  "advice.high_winrate_weak_payoff.title": "El acierto está tapando un payoff débil",
  "advice.high_winrate_weak_payoff.body": "La tasa de acierto es {winRate}, pero el payoff es {payoffRatio}. Una mala operación puede consumir varias buenas. Suele ser un problema de salida y definición de riesgo, no solo de dirección.",
  "advice.overtrade_loss_days.title": "Los días perdedores muestran aceleración",
  "advice.overtrade_loss_days.body": "{days} días tuvieron muchas operaciones y PnL negativo a la vez. Revisa aparte las operaciones después de la primera pérdida: ¿seguían el plan o intentaban recuperarla?",
  "advice.auto_expiry_losses.title": "Las pérdidas por vencimiento automático no son ruido",
  "advice.auto_expiry_losses.body": "Se incluyeron {count} pérdidas por vencimiento automático. El vencimiento a cero debe tratarse como riesgo gestionable, no como accidente de fin de sesión. Anota la última salida aceptable.",
  "advice.good_loser_base.title": "Un buen perdedor protege la siguiente operación",
  "advice.good_loser_base.body": "La ganancia media es {avgWin} y la pérdida media es {avgLoss}. Las pérdidas dentro del plan son coste operativo; las pérdidas fuera del plan indican que el riesgo debe estrecharse.",
  "advice.detach_outcome_from_ego.title": "Separa el PnL del ego",
  "advice.detach_outcome_from_ego.body": "En la revisión, pregunta primero: ¿esta pérdida ocurrió según el plan? Si sí, es coste. Si no, es un problema de disciplina.",
  "advice.large_tail_losses.title": "Reduce primero las mayores pérdidas",
  "advice.large_tail_losses.body": "{count} pérdidas superaron {threshold}. La forma más rápida de mejorar el PF no suele ser subir la tasa de acierto, sino cortar las pérdidas de cola que destruyen una semana completa.",
  "advice.asset_group_relative_edge.title": "{stronger} muestran ventaja relativa",
  "advice.asset_group_relative_edge.body": "El PF de opciones es {optionProfitFactor}; el PF de acciones es {stockProfitFactor}. Pon capital y atención donde el PF sea más estable y revisa si el bloque débil fue prueba ocasional o trading emocional.",
  "advice.option_sample_dominant.title": "La muestra actual es principalmente de opciones",
  "advice.option_sample_dominant.body": "El PF de opciones es {optionProfitFactor} con una tasa de acierto de {optionWinRate}. Revisa vencimiento, ejercicio/asignación, decisiones de la última sesión y cambios de IV por separado.",
  "advice.stock_sample_dominant.title": "La muestra actual es principalmente de acciones",
  "advice.stock_sample_dominant.body": "El PF de acciones es {stockProfitFactor} con una tasa de acierto de {stockWinRate}. Revisa tiempo de mantenimiento, consistencia del stop y entradas perseguidas antes de mezclarlo con opciones.",
  "advice.weak_option_underlying_days.title": "Revisa aparte los días débiles de opciones",
  "advice.weak_option_underlying_days.body": "{rows}. Estas combinaciones están más cerca del contexto real de decisión que la tabla resumen. Revisa primero dirección, momento de entrada y cercanía al vencimiento.",
  "advice.clean_sample.title": "Mantén limpia la muestra",
  "advice.clean_sample.body": "Ningún grupo de activos arrastra claramente el resultado. Sigue acumulando muestras limpias de operaciones cerradas y luego revisa ciclos, concentración por símbolo y estabilidad del setup.",
} satisfies Translations;
